import { useState, useRef, useEffect } from "react";
import { useFilterStore } from "../../store";
import { ENTITY_TYPE } from "../../types/marker-types";
import { isOrganizationType } from "../../utils/organization.utils";

export function OrganizationClusterCard({
    entitiesInfo,
    isMixed,
    onClose,
    onOrgSelect,
    onCompSelect
}: {
    entitiesInfo: { name: string; entityType: ENTITY_TYPE; id: string; }[];
    isMixed: boolean;
    onClose: () => void;
    onOrgSelect: (orgId: string) => void;
    onCompSelect: (compId: string) => void;
}) {
    const { filter: query, category } = useFilterStore((store) => store);
    const [activeTab, setActiveTab] = useState<'ORGS' | 'COMPS'>('ORGS');
    const listRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        if(listRef.current) {
            listRef.current.scrollTop = 0;
        }
    }, [activeTab]);

    return (
        <div className="card popup-animated">
            <div className="card__accordion">
                <div className="card-top">
                    <div className="card-top__text-box">
                        {
                            query ? query
                                : category === null ?
                                    isMixed ? `Все организации и компании`
                                        : entitiesInfo[0].entityType === ENTITY_TYPE.COMPANY ? `Все компании`
                                            : `Все образовательные организации`
                                    : category === ENTITY_TYPE.COMPANY ? "Все компании"
                                        : isOrganizationType(category) ? "Все организации" : ''
                        }
                        {
                            !isMixed ? <span className="card-top__text-box__subtitle">
                                {
                                    isMixed ? `${entitiesInfo.length} образовательных организаций и компаний`
                                        : entitiesInfo[0].entityType === ENTITY_TYPE.COMPANY ? `${entitiesInfo.length} компаний`
                                            : `${entitiesInfo.length} образовательных организаций`
                                }
                            </span> : null
                        }
                    </div>
                    <button type="button" className="card-close__btn" onClick={onClose}>
                        <ion-icon name="close"></ion-icon>
                    </button>
                </div>

                {
                    isMixed && (
                        <div className={`search-bar__tabs`}>
                            <div
                                className={`search-bar__tab ${activeTab === "ORGS" ? 'active' : ''}`}
                                onClick={() => { setActiveTab("ORGS"); }}
                            >
                                <span className="tab_text">Образование</span>
                            </div>
                            <div
                                className={`search-bar__tab ${activeTab === "COMPS" ? 'active' : ''}`}
                                onClick={() => { setActiveTab("COMPS"); }}
                            >
                                <span className="tab_text">Компании</span>
                            </div>
                        </div>)
                }

                <ul className="card__list" ref={listRef}>
                    {entitiesInfo.filter((entity) => {
                        if(!isMixed) return entity;

                        if(activeTab === 'COMPS' && entity.entityType === ENTITY_TYPE.COMPANY) return entity;
                        if(activeTab === 'ORGS' && isOrganizationType(entity.entityType)) return entity;

                        return null;
                    }).map((entity) => {
                        return (
                            <li key={entity.id} className="card__list-item">
                                <button
                                    className="list-item__button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        if(isOrganizationType(entity.entityType)) onOrgSelect(entity.id);
                                        else if(entity.entityType === ENTITY_TYPE.COMPANY) onCompSelect(entity.id);
                                    }}
                                >
                                    <span className="list-item__title">{entity.name}</span>
                                    <ion-icon name="chevron-forward"></ion-icon>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}